import { PropsWithChildren } from 'react';

function Container({ children, className = '' }: PropsWithChildren & { className?: string }) {
  return (
    <div className={`container mx-auto max-w-[1024px] w-full px-2 md:px-6 ${className}`}>
      {children}
    </div>
  );
}

export default Container;
